import { Button, Modal, Table } from 'react-bootstrap';

import { LoaderAnimation } from '../Loader';
import { LocalRoutes } from '../../../utilities/LocalRoutes';
import { ViewSameCaseTable } from '../../../pages/quad/same-cases/view/ViewSameCaseTable';
import { useGetSameCase } from '../../../pages/quad/same-cases/view/useGetSameCase';

export interface ISameCaseModalProps {
    cancelText: string;
    onCancel: () => void;
    onClose: () => void;
    open: boolean;
    params: {
        sameCaseGuid: string;
        caseFileModelId: number;
    };
    showBackdrop?: boolean;
    title: string;
}

export function SameCaseModal(props: ISameCaseModalProps) {
    const sameCaseApi = useGetSameCase(props.params.sameCaseGuid, props.params.caseFileModelId);

    const handleEasyUpdateClick = (caseGuid: string) => {
        window.open(
            LocalRoutes.QuadSameCaseEasyUpdate.replace(':sameCaseGuid', props.params.sameCaseGuid)
        );
    };

    return (
        <Modal centered show={props.open} backdrop={props.showBackdrop} size='xl'>
            <Modal.Header>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {sameCaseApi.isFetching || !sameCaseApi.data ? (
                    <>Loading...</>
                ) : (
                    <ViewSameCaseTable
                        onEasyUpdateClick={handleEasyUpdateClick}
                        sameCase={sameCaseApi.data}
                    />
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="dark" onClick={props.onCancel}>
                    {props.cancelText ?? 'Cancel'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
